// Written in this round about way for babel-transform-imports
import generatePath from "react-router/es/generatePath";

export default generatePath;


//////////////////
// WEBPACK FOOTER
// ../~/react-router-dom/es/generatePath.js
// module id = 2837
// module chunks = 1